<div class="col">
	<div class="row justify-content-center p-2">
		<div class="col-11 content-bg rounded-2">
			<div class="row embed-responsive embed-responsive-4by3">
				<iframe class="embed-responsive-item mx-auto p-2" src="https://calendar.google.com/calendar/embed?src=cb9e93478882898e41faa1374ace0debf2b9fc28496c2d3173027dceac4003bc%40group.calendar.google.com&ctz=UTC" style="border: 0" width="800" height="600" frameborder="0" scrolling="no"></iframe>
			</div>
		</div>
	</div>
</div>
